/*
Copyright (c) 2021
*/

import actions from '../../actions';

// reducer with initial state
const initialState = {
  Analysisdata: null
};

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case actions.GetSummaryDataAction.REQUEST_SUMMARYDATA:
      return {
        ...state
      };

    case actions.GetSummaryDataAction.EDIT_SUMMARYDATA:
      return {
        ...state,
        Analysisdata: {
          ...state.Analysisdata,
          analysis: action.payload.analysis
        }
      };

    case actions.GetSummaryDataAction.SUMMARYDATA_RECEIVED:
      return {
        ...state,
        Analysisdata: action.data.Analysisdata
      };

    case actions.GetSummaryDataAction.CLEAR_SUMMARYDATA:
      return {
        ...state,
        Analysisdata: null
      };

    default:
      return state;
  }
};

export default reducer;
